var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _line, _line2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 20,
    stroke: "white",
    strokeWidth: 2,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 30,
    r: 10,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 40,
    r: 10,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 80,
    r: 10,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 70,
    r: 8,
    stroke: "white",
    strokeWidth: 2,
    fill: "none"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 70,
    r: 8,
    stroke: "white",
    strokeWidth: 2,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 35,
    x2: 42,
    y2: 45,
    stroke: "white",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 45,
    x2: 58,
    y2: 55,
    stroke: "white",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 70,
    x2: 50,
    y2: 60,
    stroke: "white",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 65,
    x2: 42,
    y2: 55,
    stroke: "white",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 65,
    x2: 58,
    y2: 55,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkHealth);
export default __webpack_public_path__ + "static/media/networkHealth.e025dd57d00a93d79d77be5c52391d77.svg";
export { ForwardRef as ReactComponent };